import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "../UI/Button";
import Modal from "../UI/Modal";
import { transporteurService } from "../../services/apiService.js";
import { triggerGlobalRefresh } from "../../utils/autoRefreshWrapper.js";

const AddTransporteur = ({ onClose, onSave }) => {
  const [formData, setFormData] = useState({
    nom_de_entreprise: '',
    representant: '',
    registrationNumber: '',
    street: '',
    city: '',
    zipCode: '',
    country: '',
    email: '',
    phone: '',
    taxID: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.nom_de_entreprise || !formData.nom_de_entreprise.trim()) newErrors.nom_de_entreprise = "Le nom de l'entreprise est obligatoire";
    if (!formData.representant || !formData.representant.trim()) newErrors.representant = "Le nom du représentant est obligatoire";
    if (!formData.registrationNumber || !formData.registrationNumber.trim()) newErrors.registrationNumber = "Le numéro d'enregistrement est obligatoire";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    
    try {
      setLoading(true);
      const response = await transporteurService.add(formData);
      if (response && response.data) {
        // Passer la réponse de l'API au lieu des données du formulaire
        onSave(response.data);
        // Déclencher le refresh instantané des compteurs
        triggerGlobalRefresh('ajout', 'transporteur');
        onClose();
      }
    } catch (err) {
      setErrors({ submit: "Erreur lors de l'ajout du transporteur." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={true} onClose={null}>
      <h2 className="text-xl font-semibold text-gray-800 mb-4">Ajouter un Transporteur</h2>
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col gap-4 max-h-[70vh] overflow-y-auto pr-2">
          {[{ name: 'nom_de_entreprise', placeholder: "Nom de l'entreprise", type: 'text' },
            { name: 'representant', placeholder: "Nom du représentant", type: 'text' },
            { name: 'registrationNumber', placeholder: "Numéro d'enregistrement ou SIRET", type: 'text' },
            { name: 'taxID', placeholder: "Numéro de TVA", type: 'text' },
            { name: 'street', placeholder: "Adresse (rue)", type: 'text' },
            { name: 'city', placeholder: "Ville", type: 'text' },
            { name: 'zipCode', placeholder: "Code postal", type: 'text' },
            { name: 'country', placeholder: "Pays", type: 'text' },
            { name: 'email', placeholder: "Adresse email", type: 'email' },
            { name: 'phone', placeholder: "Téléphone", type: 'tel' },
          ].map((field) => (
            <div key={field.name} className="w-full">
              <input
                type={field.type}
                name={field.name}
                value={formData[field.name] || ''}
                onChange={handleChange}
                className={`w-full border rounded-lg p-2 ${errors[field.name] ? 'border-red-500' : 'border-gray-300'}`}
                placeholder={field.placeholder}
              />
              {errors[field.name] && (
                <p className="text-red-500 text-xs mt-1">{errors[field.name]}</p>
              )}
            </div>
          ))}
          {errors.submit && (
            <div className="p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg">
              {errors.submit}
            </div>
          )}
        </div>
        <div className="flex justify-end space-x-3 mt-4">
          <Button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="bg-gray-400 text-white hover:bg-gray-500"
          >
            Annuler
          </Button>
          <Button
            type="submit"
            disabled={loading}
            className="bg-blue-600 text-white hover:bg-blue-700"
          >
            {loading ? 'Ajout en cours...' : 'Ajouter'}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

AddTransporteur.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default AddTransporteur; 